import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../api/api';
import { LOADING_STATUSES } from '../../constants/statuses';
import { getTokenData } from "src/utils/api";
import { isResponseSuccess } from "src/utils/api";

export const loadAllCurrency = createAsyncThunk(
  'currency/load',
  async (_, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const response = await API(getTokenData()).BASIC.CURRENCIES.load();
      if (isResponseSuccess(response.status)) {
        return response.data || [];
      }
      return [];
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  },
);

const initialState = {
  allCurrency: [],
  status: LOADING_STATUSES.IDLE,
  error: null,
};

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAllCurrency.pending, (state) => {
        state.status = LOADING_STATUSES.LOADING;
        state.error = null;
      })
      .addCase(loadAllCurrency.fulfilled, (state, action) => {
        state.allCurrency = action.payload;
        state.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadAllCurrency.rejected, (state, action) => {
        state.status = LOADING_STATUSES.FAILED;
        state.error = action.payload;
      });
  },
});

export default currenciesSlice.reducer;
